<template>
  <div class="content-430">
    <div class="class-form-head">
      课程材料
    </div>
    <div class="class-form-content">
      <Form ref="materialInfo" :model="materialInfo" label-position="right" :label-width="120" :rules="materialInfoRule">
        <FormItem
          label="材料费用"
          prop="attachmentPriceShow"
        >
          <Input
            v-model="materialInfo.attachmentPriceShow"
            placeholder="请填写"
            class="w-40"
            @on-blur="getTrueFee('attachmentPrice',materialInfo.attachmentPriceShow)"
          ></Input>
          <div>
            若无材料费用不填写
          </div>
        </FormItem>
        <FormItem label="材料名称" prop="attachmentDescribe">
          <Input
            v-model="materialInfo.attachmentDescribe"
            placeholder="请填写"
            class="w-40"
            maxlength="20"
          ></Input>
        </FormItem>
      </Form>
    </div>
  </div>
</template>
<script>
export default {
  inject: ['EditCurriculumInstance'],
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          courseCoverShow: null, // 课程封面展示
          courseCover: '', // 课程封面
          courseDescribe: '', // 课程介绍
          courseAchievementShow: [], // 成果展示
          courseAchievement: '', // 成果展示
          coursePriceShow: '', // 页面展示的校内单价
          coursePrice: '', // 校内单价(页面展示的校内单价*100)
          outCoursePriceShow: '', // 页面展示的校外单价
          outCoursePrice: '' // 校外单价(页面展示的校外单价*100)
        };
      }
    }, // v-model的值
    theUserIdentity: {
      type: String,
      default: ''
    },
    courseId: {
      type: String,
      default: ''
    },
    downloadUrl: {
      type: String,
      default: ''
    },
    validatePass: {
      type: Boolean,
      default: false
    } // 校验是否通过
  },
  data() {
    // 课程价格规则
    const validateCoursePrice = (rule, value, callback) => {
      if (value === '' || value === null) {
        this.EditCurriculumInstance.findRuleRequireNew(this, 'materialInfo', '课程材料');
        callback();
        return;
      }
      const number = Number(value);
      if (isNaN(number)) {
        callback(new Error('请输入正确的数字'));
        return;
      }
      if (number < 0) {
        callback(new Error('请输入大于或等于0的金额'));
        return;
      }
      let length = 0;
      const arr = value.split('.');
      if (arr.length === 2) {
        length = arr[1].length;
      }
      if (length > 2) {
        callback(new Error('请输入最多两位小数的金额'));
      } else {
        this.EditCurriculumInstance.findRuleRequireNew(this, 'materialInfo', '课程材料');
        callback();
      }
    };
    return {
      materialInfoRule: {
        attachmentPriceShow: [{ validator: validateCoursePrice, trigger: 'blur' }]
      } // 基础信息表单
    };
  },
  computed: {
    materialInfo: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    }
  },
  mounted() {
    this.EditCurriculumInstance.findRuleRequireNew(this, 'materialInfo', '课程材料');
  },
  methods: {
    // 校验表单
    checkForm() {
      this.$refs.materialInfo.validate((valid) => {
        if (valid) {
          this.EditCurriculumInstance.findRuleRequireNew(this, 'materialInfo', '课程材料');
          this.$emit('update:validatePass', true);
        } else {
          this.EditCurriculumInstance.findRuleRequireNew(this, 'materialInfo', '课程材料', true);
          this.$emit('update:validatePass', false);
        }
      });
    },
    getTrueFee(tag, value) {
      if (value) {
        this.materialInfo[tag] = value * 100;
      } else {
        this.materialInfo[tag] = '';
      }
    }
  }
};
</script>
<style lang="scss" scoped>

</style>
